<div [ngBusy]="{busy: busy, message: ('common.pleaseWait' | translate)}">
  <i class="icon-close cursor-pointer outer-modal-close" (click)="modal.dismiss()"></i>

  <login-form
    *ngIf="showedForm===AUTH_FORMS.LOGIN"
    [error]="error"
    [resetPasswordRequired]="resetPasswordRequired"
    [hideFooter]="hideLoginFormFooter"
    (onSubmit)="login($event)"
    (onFormChange)="showedForm=$event; error=''"
    (onResetPassword)="resetRequest($event)"
  ></login-form>

  <register-forms-wrapper
    *ngIf="showedForm===AUTH_FORMS.REGISTER || showedForm===AUTH_FORMS.REGISTER_BUSINESS"
    [activeTab]="accountType"
    (onFormChange)="showedForm=AUTH_FORMS.LOGIN; error=''"
    (onAccountTypeChanged)="accountType=$event">
    <register-private-account-form
      *ngIf="accountType === USER_ACCOUNT_TYPE.GENERAL"
      [countryCode]="countryCode"
      [error]="error"
      (onSubmit)="register($event)"
    ></register-private-account-form>

    <register-business-account-form
      *ngIf="accountType === USER_ACCOUNT_TYPE.SHARED_BUSINESS_ACCOUNT"
      [countryCode]="countryCode"
      [error]="error"
      (onSubmit)="register($event)"
    ></register-business-account-form>
  </register-forms-wrapper>

  <lost-password-form
    *ngIf="showedForm===AUTH_FORMS.LOST_PASSWORD"
    [requestSuccess]="resetRequestSuccess"
    [error]="error"
    (onSubmit)="resetRequest($event)"
    (onFormChange)="showedForm=$event; error=''"
  ></lost-password-form>
</div>
